import React, { useState, useEffect } from "react";
import { api } from "./api";
import "../../../css/blogs.css"; // Import the CSS file

export const CategoryFilter = ({
  activeCategory,
  onCategoryChange,
  style,
  className = "",
}) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    try {
      const response = await api.categories.getAll();
      // Ensure response.categories is an array before mapping
      if (!Array.isArray(response?.categories)) {
        console.error("Invalid categories data received:", response);
        return [];
      }
      return response.categories.map((category) => ({
        _id: category.id,
        name: category.name,
        slug: category.slug,
        description: category.description,
        parentCategory: category.parentCategory,
      }));
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchCategories();
        setCategories(data);
      } catch (error) {
        setError("Failed to load categories.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className={`category-filter-container ${className}`} style={style}>
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="category-filter-loading-shimmer" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className={`category-filter-error ${className}`} style={style}>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className={`category-filter-container ${className}`} style={style}>
      <button
        key="all"
        onClick={() => onCategoryChange("")}
        className={`category-filter-button ${
          activeCategory === ""
            ? "category-filter-button-active"
            : "category-filter-button-inactive"
        }`}
      >
        All Posts
      </button>

      {categories.map((category) => (
        <button
          key={category._id}
          onClick={() => onCategoryChange(category.slug)}
          className={`category-filter-button ${
            activeCategory === category.slug
              ? "category-filter-button-active"
              : "category-filter-button-inactive"
          }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
};
